import { QuoteProps } from "../components/Quote/types";

export const quote: QuoteProps = {
  displayValue:
    "Thank you Jeannie, for making our perfect day even more beautiful",
  value: "Bride, Katelin O.",
};
